import { Component, Input, ViewEncapsulation } from '@angular/core';

import { DashpivotEvent, EventNotifierService, EventTypes } from '@site-mate/dashpivot-shared-library';

import { SegmentService } from 'app/segment/segment.service';
import { AccordionPanel } from 'app/shared/model/accordion-panel.model';

@Component({
  selector: 'cc-trial-start-guide-accordion',
  templateUrl: './trial-start-guide-accordion.component.html',
  styleUrls: ['./trial-start-guide-accordion.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class TrialStartGuideAccordionComponent {
  @Input() accordionPanels: AccordionPanel[];

  constructor(private readonly segmentService: SegmentService) {}

  trackAccordionClick(eventType: EventTypes, context: string): void {
    void EventNotifierService.notify(
      new DashpivotEvent(eventType, { Context: context }),
      this.segmentService,
    );
  }
}
